export const DOWNLOAD_HOST = "blob.core.windows.net";
